var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.000000, 20.000000) rotate(-270.000000) translate(-217.000000, -20.000000) translate(209.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,4.9640625 L7.4046875,4.9640625 L7.4046875,10.25 C7.4046875,10.31875 7.4609375,10.375 7.5296875,10.375 L8.4671875,10.375 C8.5359375,10.375 8.5921875,10.31875 8.5921875,10.25 L8.5921875,4.9640625 L9.75,4.9640625 C9.8546875,4.9640625 9.9125,4.84375 9.8484375,4.7625 L8.0984375,2.546875 C8.0484375,2.4828125 7.9515625,2.4828125 7.9015625,2.546875 L6.1515625,4.7609375 C6.0875,4.84375 6.1453125,4.9640625 6.25,4.9640625 L6.25,4.9640625 Z M13.71875,5.78125 L12.78125,5.78125 C12.7125,5.78125 12.65625,5.8375 12.65625,5.90625 L12.65625,12.3125 L3.34375,12.3125 L3.34375,5.90625 C3.34375,5.8375 3.2875,5.78125 3.21875,5.78125 L2.28125,5.78125 C2.2125,5.78125 2.15625,5.8375 2.15625,5.90625 L2.15625,13 C2.15625,13.2765625 2.3796875,13.5 2.65625,13.5 L13.34375,13.5 C13.6203125,13.5 13.84375,13.2765625 13.84375,13 L13.84375,5.90625 C13.84375,5.8375 13.7875,5.78125 13.71875,5.78125 Z",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.575b76d33d440d61af143b5b68601136.svg";
export { ForwardRef as ReactComponent };